/* Milagros · Sobre nosotros. Sin dependencias. Solo se carga en esta plantilla. */
(function () {
  'use strict';
  if (window.mlAboutInit) return;
  window.mlAboutInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  function headerOffset() {
    var h = parseFloat(getComputedStyle(root).getPropertyValue('--header-height')) || 0;
    var toc = document.querySelector('.ml-toc');
    return h + (toc ? toc.offsetHeight : 0);
  }

  /* ---------- Índice: sección activa, progreso y desplazamiento ---------- */
  function initToc() {
    var toc = document.querySelector('.ml-toc');
    if (!toc) return;
    var list = toc.querySelector('.ml-toc__list');
    var bar = toc.querySelector('.ml-toc__bar');
    var links = Array.prototype.slice.call(toc.querySelectorAll('a[href^="#"]'));
    var map = {};
    var secs = [];
    links.forEach(function (a) {
      var id = decodeURIComponent(a.getAttribute('href').slice(1));
      var el = document.getElementById(id);
      if (el) { map[id] = a; secs.push(el); } else { a.parentElement.hidden = true; }
    });
    if (!secs.length) return;
    var current = null;
    var ticking = false;

    function activate(id) {
      links.forEach(function (a) { a.removeAttribute('aria-current'); });
      var a = map[id];
      if (!a) return;
      a.setAttribute('aria-current', 'true');
      var left = a.offsetLeft - list.clientWidth / 2 + a.offsetWidth / 2;
      list.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var off = headerOffset() + 40;
        var cur = null;
        for (var i = 0; i < secs.length; i++) {
          if (secs[i].getBoundingClientRect().top - off <= 0) cur = secs[i].id;
        }
        var last = secs[secs.length - 1];
        if (last.getBoundingClientRect().bottom < off) cur = null;
        if (cur !== current) {
          current = cur;
          if (cur) activate(cur); else links.forEach(function (a) { a.removeAttribute('aria-current'); });
        }
        if (bar) {
          var max = root.scrollHeight - root.clientHeight;
          var p = max > 0 ? window.scrollY / max : 0;
          bar.style.width = Math.max(0, Math.min(1, p)) * 100 + '%';
        }
      });
    }
    function go(id, updateHash) {
      var el = document.getElementById(id);
      if (!el) return;
      var y = el.getBoundingClientRect().top + window.scrollY - headerOffset() + 1;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      if (updateHash && history.replaceState) history.replaceState(null, '', '#' + id);
      var h = el.querySelector('h2, h1');
      if (h) {
        h.setAttribute('tabindex', '-1');
        setTimeout(function () { h.focus({ preventScroll: true }); }, reduce ? 0 : 450);
      }
    }
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        go(decodeURIComponent(a.getAttribute('href').slice(1)), true);
      });
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
    if (location.hash) {
      var id = decodeURIComponent(location.hash.slice(1));
      if (map[id]) setTimeout(function () { go(id, false); }, 150);
    }
  }

  /* ---------- Enlace directo junto a cada H2 ---------- */
  function initDeepLinks() {
    var toast = document.createElement('div');
    toast.className = 'ml-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
    var t;
    function say(msg) {
      toast.textContent = msg;
      toast.classList.add('is-on');
      clearTimeout(t);
      t = setTimeout(function () { toast.classList.remove('is-on'); }, 1800);
    }
    document.querySelectorAll('.ml-about[id] h2').forEach(function (h) {
      var sec = h.closest('.ml-about[id]');
      if (!sec || h.querySelector('.ml-hl')) return;
      var a = document.createElement('a');
      a.className = 'ml-hl';
      a.href = '#' + sec.id;
      a.setAttribute('aria-label', 'Copiar enlace a esta sección');
      a.textContent = '#';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var url = location.href.split('#')[0] + '#' + sec.id;
        if (history.replaceState) history.replaceState(null, '', '#' + sec.id);
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () { say('Enlace copiado'); }, function () { say('Enlace listo en la barra de direcciones'); });
        } else {
          say('Enlace listo en la barra de direcciones');
        }
      });
      h.appendChild(a);
    });
  }

  /* ---------- YouTube bajo demanda (no carga nada hasta el clic) ---------- */
  function initYouTube() {
    document.querySelectorAll('.ml-yt[data-yt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-yt');
        if (!/^[\w-]{6,20}$/.test(id)) return;
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
        f.title = btn.getAttribute('aria-label') || 'Video';
        f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        f.allowFullscreen = true;
        f.referrerPolicy = 'strict-origin-when-cross-origin';
        btn.innerHTML = '';
        btn.appendChild(f);
        btn.removeAttribute('data-yt');
      }, { once: true });
    });
  }

  /* ---------- Video en loop: solo se reproduce visible y sin movimiento reducido ---------- */
  function initLoops() {
    var vids = document.querySelectorAll('.ml-loop video');
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
    });
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: 0.2 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function init() {
    initToc();
    initDeepLinks();
    initYouTube();
    initLoops();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();